import { Navigate } from 'react-router-dom';
import LoaderPreDS from 'components/LoaderPreDS/LoaderPreDS';
import { usePermissions } from 'context/PermissionsContext';
import { useAuth } from 'context/AuthContext';

const PermissionRoute = ({
  requiredModule,
  anyModules = [],
  allModules = [],
  element,
  fallbackTo = '/',
}) => {
  const { initializing } = useAuth();
  const {
    hasModuleAccess,
    hasAnyModuleAccess,
    hasAllModuleAccess,
    permissionsLoading,
  } = usePermissions();

  if (initializing || permissionsLoading) return <LoaderPreDS />;
  const hasRules =
    !!requiredModule ||
    (Array.isArray(anyModules) && anyModules.length > 0) ||
    (Array.isArray(allModules) && allModules.length > 0);

  if (!hasRules) return element;

  const hasRequiredModule = requiredModule
    ? hasModuleAccess(requiredModule)
    : true;
  const hasAnyModules = anyModules.length
    ? hasAnyModuleAccess(anyModules)
    : true;
  const hasAllModules = allModules.length
    ? hasAllModuleAccess(allModules)
    : true;

  return hasRequiredModule && hasAnyModules && hasAllModules ? (
    element
  ) : (
    <Navigate to={fallbackTo} replace />
  );
};

export default PermissionRoute;
